<template>
    <div class="lucky-note-layout">
        <commonHeader :title="dataList.name" />
        <div class="headTip">
            <p>{{$t('luckyNote.topTips1')}}{{dailyAppCount}}{{$t('luckyNote.topTips2')}}</p>
        </div>
        <div class="lucky-note-container">
            <div class="title">
                <span class="flag"></span>
                <span class="name">{{$t('luckyNote.title')}}</span>
            </div>
            <!-- <el-scrollbar style="height:136px;padding-right:2px"> -->
            <el-table
                :data="unreceivedList"
                style="width: 100%"
                highlight-current-row
                max-height="373"
                :empty-text="$t('luckyNote.emptyText1')"
                @current-change="handleCurrentChange"
            >
                <el-table-column :label="$t('luckyNote.platForm')" width="120">
                    <template slot-scope="scope">{{ scope.row.vendorCode}}</template>
                </el-table-column>
                <el-table-column :label="$t('luckyNote.gameTime')" width="200">
                    <template slot-scope="scope">{{ scope.row.betTime | timeSwitchAll }}</template>
                </el-table-column>
                <el-table-column prop="betAmount" :label="$t('luckyNote.betMoney')" width="120"></el-table-column>
                <el-table-column prop="betNo" :label="$t('luckyNote.luckyNoteNum')" width="200"></el-table-column>
                <el-table-column prop="amount" :label="$t('luckyNote.actGift')" width="120"></el-table-column>
                <el-table-column :label="$t('luckyNote.operation')">
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="applyFn(scope.row)"
                            v-if="!received"
                            type="text"
                            size="small"
                        >{{$t('Anniversary.tip17')}}</el-button>
                        <el-button
                            v-else
                            type="text"
                            size="small"
                            disabled
                        >{{$t('luckyNote.applyed')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- </el-scrollbar> -->
            <div class="lucky-note-tips">
                <div class="tips">
                    <span>{{$t('weekAward.botTips')}}</span>
                    {{$t('luckyNote.middleTips')}}
                </div>

                <div class="texts">
                    {{$t('luckyNote.text1')}}
                    <span
                        @click="toCustomerService()"
                    >{{$t('luckyNote.text2')}}</span>
                    {{$t('luckyNote.text3')}}
                    <span
                        @click="toCustomerService()"
                    >{{$t('luckyNote.text4')}}</span>
                    {{$t('luckyNote.text5')}}
                </div>
            </div>
        </div>

        <div class="apply-record-container">
            <div class="title">
                <span class="flag"></span>
                <span class="name">{{$t('luckyNote.applyRecords')}}</span>
            </div>

            <el-table
                :data="receivedList"
                style="width: 100%"
                :empty-text="$t('luckyNote.emptyText2')"
            >
                <el-table-column :label="$t('luckyNote.applyTime')" width="200">
                    <template slot-scope="scope">{{ scope.row.receiveTime | timeSwitchAll }}</template>
                </el-table-column>
                <el-table-column
                    prop="vendorCode"
                    :label="$t('luckyNote.applyPlatForm')"
                    width="150"
                ></el-table-column>
                <el-table-column prop="betNo" :label="$t('luckyNote.betNum')" width="150"></el-table-column>
                <el-table-column prop="amount" :label="$t('luckyNote.awardMoney')" width="150"></el-table-column>
                <el-table-column
                    prop="betAmountValid"
                    :label="$t('luckyNote.effBetMoney')"
                    width="150"
                ></el-table-column>
                <el-table-column
                    fixed="right"
                    prop="remark"
                    :label="$t('luckyNote.remarks')"
                    width="120"
                ></el-table-column>
            </el-table>

            <div class="apply-record-tips">
                <span class="black">{{$t('weekAward.botTips')}}</span>
                <span class="blue cursorPoint" @click="openDetail">{{$t('luckyNote.clickThis')}}</span>
                <span class="gray">{{$t('luckyNote.luckyNotedetail')}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import commonHeader from "./commonHeader.vue";
export default {
    components: {
        commonHeader
    },
    data() {
        return {
            dataList: {},
            currentRow: null, //当前选中行
            award: "xxx", //领取的奖励
            id: "", //活动id
            receivedList: [],
            unreceivedList: [],
            dailyAppCount: "",
            received: false //领取状态  false表示还未领取
        };
    },
    filters: {
        timeSwitch(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + ".";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + ".";
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var time = Y + M + D;
                return time;
            }
        },
        timeSwitchAll(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                var D =
                    (date.getDate() < 10
                        ? "0" + date.getDate()
                        : date.getDate()) + " ";
                var h =
                    (date.getHours() < 10
                        ? "0" + date.getHours()
                        : date.getHours()) + ":";
                var m =
                    (date.getMinutes() < 10
                        ? "0" + date.getMinutes()
                        : date.getMinutes()) + ":";
                var s =
                    date.getSeconds() < 10
                        ? "0" + date.getSeconds()
                        : date.getSeconds();
                var time = Y + M + D + h + m + s;
                return time;
            }
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getData();
    },
    methods: {
        async getData() {
            const res = await this.$http.get(
                this.$api.getThematicActivitiesByApp + "/" + this.id,
                "",
                true
            );
            if (res.code == 0) {
                this.dataList = res.data;
                this.dailyAppCount = res.data.speActLuckyTimesVO.dailyAppCount;
                this.receivedList = res.data.speActLuckyTimesVO.receivedList;
                this.unreceivedList =
                    res.data.speActLuckyTimesVO.unreceivedList;
                this.received = res.data.speActLuckyTimesVO.received;

                // this.todayReceivedList = this.receivedList.filter(item => {
                //     new Date(item.receiveTime).toDateString() ==
                //         new Date().toDateString();
                // });
            }
        },
        handleCurrentChange(val) {
            //选中行
            this.currentRow = val;
        },
        applyFn(item) {
            var _this = this;
            this.$confirm(_this.$t("luckyNote.isConfirmApply"), "", {
                confirmButtonText: _this.$t("luckyNote.confirm"),
                cancelButtonText: _this.$t("luckyNote.cancel"),
                showClose: false
            }).then(() => {
                //申请
                this.getFn(item);
            });
        },
        async getFn(item) {
            const res = await this.$http.put(
                this.$api.getReceive +
                    item.thematicActivitiesId +
                    "&betNo=" +
                    item.betNo
            );
            if (res.code == 0) {
                this.$message({
                    type: "success",
                    message: res.data
                });
                this.getData(this.id);
                //更新余额
                this.getuserMoney();
            } else {
                this.$message({ type: "warning", message: res.msg });
            }
        },
        getuserMoney() {
            this.$nkhttp.getuserMoney(
                res => {
                    if (res.code == 0) {
                        this.$message.success(this.$t("accountPage.Refresh"));
                    } else {
                        this.$message.error(res.msg || "请求失败");
                    }
                },
                false,
                true
            );
        },
        openDetail() {
            this.$router.push({
                path: "/discount",
                query: {
                    flag: true,
                    name: this.dataList.name,
                    startTime: this.dataList.startTime,
                    endTime: this.dataList.endTime,
                    forever:this.dataList.forever,
                }
            });
            localStorage.setItem("disIntro", this.dataList.intro);
        },
        toCustomerService() {
            if (window.customerServiceStatus == 1) {
                //新客服
                var _this = this;
                var obj = {};
                obj.host = _this.$common.getHost();
                obj.clientCode = window.clientCode;
                obj.clientItem = window.childCode;
                obj.username =
                    this.$common.getUser() && this.$common.getUser().username;
                obj.language = this.$common.getLocale();
                obj.theme = window.theme;
                obj.projectImgUrl = window.projectImgUrl;
                obj.orgin = window.location.origin + "/activity";
                var str = JSON.stringify(obj);
                str = window.btoa(str);
                // var url =
                //     _this.$config.customerServiceUrl +
                //     "/customerService/pc?s=" +
                //     str;
                var url = location.origin + "/func/customerService/pc?s=" + str;
                window.open(url, "_blank");
            } else {
                //旧客服
                const url = this.$common.getCustomerService();
                window.open(url, "_blank");
            }
        }
    }
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.lucky-note-layout {
    .headTip {
        margin: 20px 0;
        background-color: #fff4d7;
        color: #e91919;
        font-size: 12px;
        padding: 10px;
    }
    .title {
        overflow: hidden;
        margin-bottom: 15px;
        .flag {
            width: 4px;
            height: 21px;
            float: left;
            background: #e91919;
            margin-right: 8px;
        }
        .name {
            font-size: 14px;
            font-weight: bold;
            line-height: 21px;
            float: left;
            color: #333333;
        }
    }

    ::v-deep .el-table {
        &::before {
            height: 0;
        }
        thead {
            color: #333;
        }
        .el-table__body {
            tr.current-row > td {
                background-color: #f6f6f6;
            }
        }
        th,
        td {
            text-align: center;
            padding-top: 0;
            padding-bottom: 0;
            height: 34px;
            line-height: 34px;
        }
        th {
            background-color: #f5f5f5;
        }
        .el-button--text {
            width: 70px;
            height: 24px;
            line-height: 24px;
            background: #e91919;
            box-shadow: 0px 3px 6px rgba(230, 79, 79, 0.16);
            opacity: 1;
            border-radius: 12px;
            font-size: 12px;
            color: #fff;
            padding: 0;
        }
        .el-button--text.is-disabled {
            opacity: 0.5;
        }
        .cell {
            position: relative;
            font-weight: normal;
        }
        .selectImg {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 15px;
            width: 16px;
            height: 16px;
            flex-shrink: 0;
        }
        .el-table__empty-block {
            height: 34px !important;
            min-height: 34px;
            .el-table__empty-text {
                color: #333;
                font-size: 12px;
            }
        }

        // .el-table__body-wrapper::-webkit-scrollbar {
        //     display: block;
        //     width: 6px;
        //     height: 6px;
        //     background-color: rgba(245, 245, 245, 0.47);
        // }
        // /*定义滚动条的轨道，内阴影及圆角*/
        // .el-table__body-wrapper::-webkit-scrollbar-track {
        //     -webkit-box-shadow: inset 0 0 6px #f4f4f4;
        //     border-radius: 10px;
        //     background-color: #f4f4f4;
        // }

        // /*定义滑块，内阴影及圆角*/
        // .el-table__body-wrapper::-webkit-scrollbar-thumb {
        //     /*width: 10px;*/
        //     height: 20px;
        //     border-radius: 10px;
        //     background-color: #e91919;
        // }
    }

    .lucky-note-container {
        .lucky-note-tips {
            padding: 16px 0;
            border-bottom: 1px solid #e8e8e8;
            box-sizing: border-box;
            .tips {
                font-size: 12px;
                line-height: 17px;
                color: #999999;
                margin-bottom: 12px;
                span {
                    color: #333333;
                }
            }
            .texts {
                font-size: 12px;
                line-height: 17px;
                color: #333333;
                span {
                    color: #e91919;
                    cursor: pointer;
                }
            }
        }
        ::v-deep .el-table {
        }
    }
    .apply-record-container {
        padding: 16px 0;
        .apply-record-tips {
            font-size: 12px;
            line-height: 17px;
            padding-top: 16px;
            .black {
                color: #333333;
            }
            .blue {
                color: #0066cc;
            }
            .gray {
                color: #999999;
            }
        }
        ::v-deep .el-table {
            border-top: 1px solid #e8e8e8;
            th {
                background-color: #fff;
            }
            .el-table__empty-block {
                width: auto !important;
                background-color: #f5f5f5;
            }
        }
    }
}
</style>